/* eslint-disable no-undef */
import Appsignal from '@appsignal/javascript';

// Substituted at build time by esbuild (see the `define` in esbuild.mjs). typeof-guarded so that
// a bundle built without that define degrades to development instead of throwing a ReferenceError
// at module load, which would take down every pack that imports this.
const environment = typeof __SUPERCAST_JS_ENV__ === 'string' ? __SUPERCAST_JS_ENV__ : 'development';

let appsignalKey;

switch (environment) {
  case 'development':
  case 'test':
    appsignalKey = '1351c37f-234b-4022-aec3-0565a0ed6fdb';
    break;
  case 'staging':
    appsignalKey = '0d3a8090-4974-4e92-b75f-03cebdba89ea';
    break;
  case 'production':
    appsignalKey = '8a3ef517-ca57-47fc-bad1-96b4b5aaafe0';
    break;
}

export default new Appsignal({
  key: appsignalKey
})